import { useEffect } from 'react';

const YektanetScript = () => {
  useEffect(() => {
    if (document.getElementById('ua-script-ahdCjIoX')) return; // جلوگیری از درج مجدد
    const a = new Date();
    const r = a.getFullYear().toString() + "0" + a.getMonth() + "0" + a.getDate() + "0" + a.getHours();
    const s = document.createElement('script');
    s.id = "ua-script-ahdCjIoX";
    s.dataset.analyticsobject = "yektanet";
    s.async = 1;
    s.type = "text/javascript";
    s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/ahdCjIoX/rg.complete.js?v=" + r;
    document.head.appendChild(s);
    return () => {
      s.remove();
    };
  }, []);
  return null;
};

export default YektanetScript; 